import React from 'react';
import c from 'classnames';
import { convertNodeToElement, type Transform } from 'react-html-parser';

import { CookieWrapper, WysiwygField } from '@uncinc/uncinc-react-kitchen-sink';

import type { WysiwygFieldDomElement } from '../../../types';
import type { IMap } from '../types';

export interface WebformProcessedTextProps {
  entity: IMap;
}

const WebformProcessedText: React.FC<WebformProcessedTextProps> = ({ entity }) => {
  const classes = c('WebformProcessedText', (entity.getIn(['#wrapper_attributes', 'class', 0], '') as string));

  return (
    <WysiwygField
      property="schema:text"
      className={classes}
      html={entity.get('#text', '')}
      // eslint-disable-next-line react/no-unstable-nested-components
      customElementHandler={(
        node: WysiwygFieldDomElement,
        index: number,
        transform?: Transform,
      ) => {
        switch (node.name) {
          case 'iframe': {
            return (
              <CookieWrapper>
                {convertNodeToElement(node, index, transform)}
              </CookieWrapper>
            );
          }

          default:
            return null;
        }
      }}
    />
  );
};

export default WebformProcessedText;
